export interface WithdrawViewData {
    channelList: any[],
    activeChannel: any,
    balanceAmount: number,
    selectedAmount: number | string,
    activeButton: boolean,
    uId: any,
}

export interface WithdrawPopupData {
show?: boolean,
selectedChannel : Channel,
activeTab : any,
cpfID : string,
emailID : string,
phoneID : string,
evpID : string,
userName : string,
cpfNumber : string,
brazilID : string,
bank : string,
showCPFIdError : boolean,
showEmaiIdError : boolean,
showPhoneIdError : boolean,
showEvpIdError : boolean,
showCPFNumError : boolean,
activeButton : boolean,
selectedAmount : number,
isDisabled : boolean,
}
export interface Channel {
    id: number | string;
    name: string;
}

export const TAB_TYPE_LIST = ([
{ id: 1, name: "CPF", errorText: "withdraw.cpfErrorText" },
{ id: 2, name: "E-mail", errorText: "withdraw.emailErrorText" },
{ id: 3, name: "PHONE", errorText: "withdraw.phoneErrorText" },
{ id: 4, name: "EVP", errorText: "withdraw.evpErrorText" },
])